import React, { Component } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import _ from "i18n";
import styles from "../CalendarSettings/CalendarSettings.local.scss";
import ItemMonth from "../CalendarSettings/ItemMonth";
import { TTPModal } from "../Common/Modal/TTPModal";
import {
  setCalendarModifiers,
  setCalendarSelectedDays,
  setCalendarSelectedFiles,
  setCalendarActivatedOption,
  initCalendarSelect,
  setCalendarPlanning,
  setCalendarId,
  initCalendarConfig
} from "Actions";
import {
  saveCollaboratorAbsenceCalendarSettings,
  fetchCollaboratorAbsenceCalendarSettings,
  fetchCollaboratorSuggestions,
  sendGenericEmailThunk
} from "Thunks";
import { MONTHS, STATUS_VACATION, VACATION_STATUS_CONFIG } from "Config";
import {
  getTemporaryAnnexeFileLink,
  mapAndSortCalendarPlanningByMonth,
  filterCollaboratorDatesTagsByOptions,
  prepareCollaboratorAbsencesForSave,
  filterDates,
  onSuccess,
  onError
} from "Utils";
import ModalCloseButton from "../Common/Modal/ModalCloseButton";
import { GarbageIcon } from "../Common/Icons";
import { DIALOG_TYPES, YEARS_VALUES } from "../../config";
import TTPDialog from "../Common/TTPDialog";
import clonedeep from "lodash.clonedeep";
import { selectLoggedAs } from "Selectors";
import {
  isCollaboratorAccess,
  isManagerAccess,
  isAdminAccess,
  isSuperAdminAccess
} from "Utils";
import { Popconfirm, Tag, Tooltip, Modal } from "antd";

import "moment/locale/fr";
import "moment/locale/nl";
import NotFoundV2 from "../NotFound/NotFoundV2";
import StateFilter from "../Common/StateFilter/StateFilter";

const HOLIDAYS_COLOR = "#FF636E";
// const WORKING_DAYS_COLOR = "#02AF8E";
const ANNUAL_HOLIDAYS_COLOR = "#F7953E";
const ABSENCES_COLOR = "#4695DB";
const OTHER_ABSENCES_COLOR = "#796AD9";
const POP_STATUS = { REJECT: "REJECT", APPROVE: "APPROVE" };

class CalendarSettingsPage extends Component {
  constructor(props) {
    super(props);

    const { lng } = this.props;

    const moment = require("moment");
    moment.locale(lng);

    this.itemMonthRefs = [];
    MONTHS.forEach(() => {
      this.itemMonthRefs.push(React.createRef());
    });

    this.state = {
      months: moment.months(),
      yearDivIsVisible: false,
      isAttachmentModalVisible: false,
      year: props.date ? props.date.year() : moment().year(),
      activated: null,
      deleteTagDatesIsVisible: false,
      selectedTagKey: null,
      selectedTagDates: [],
      selectedTagOption: [],
      holidaysNbrOfDays: {
        absence_1: 0,
        absence_2: 0,
        absence_3: 0,
        absence_sl: 0
      },
      seniorityLeave: null,
      collaborators: [],
      popStatus: null,
      selectedAttachments: [],
      confirmLoading: false,
      selectedVacationState: [],
      vacationStatusConfig: VACATION_STATUS_CONFIG
    };
  }

  componentDidMount() {
    let collaborators = [];
    this.fetchCollaboratorAbsenceCalendar();
    this.props.dispatch(fetchCollaboratorSuggestions()).then(res => {
      res.value.data.data.map(t => {
        collaborators.push({
          value: t.id,
          label: t.name
        });
      });
    });
    this.setState({ collaborators });
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      year,
      dispatch,
      data: { planning }
    } = this.props;
    if (prevProps.data.planning !== planning) {
      this.handlePlaningChange();
    }
    if (prevProps.year !== year) {
      this.setState({ year });
      dispatch(initCalendarConfig());
      dispatch(fetchCollaboratorAbsenceCalendarSettings(year));
    }
  }

  fetchCollaboratorAbsenceCalendar = () => {
    const { dispatch, year } = this.props;
    const moment = require("moment");
    let yearLocal = this.props.date ? this.props.date.year() : moment().year();

    document.addEventListener(
      "mousedown",
      this.handleClickOutsideYearSelect.bind(this)
    );
    this.handleVacationStateChange([VACATION_STATUS_CONFIG[0]["id"]]);

    dispatch(initCalendarConfig());
    dispatch(fetchCollaboratorAbsenceCalendarSettings(yearLocal));
  };

  handlePlaningChange = () => {
    const {
      data: { planning }
    } = this.props;
    let plan = planning;

    let hydratedMonths = [];
    let options = [];
    for (let type in plan) {
      options.push(type);
    }

    for (let i in MONTHS) {
      let tags = mapAndSortCalendarPlanningByMonth(plan, MONTHS[i], options);

      if (tags.length === 0) {
        continue;
      }

      hydratedMonths.push(tags);
    }

    let vacationStatusConfigClone = clonedeep(VACATION_STATUS_CONFIG);

    for (const item1 of hydratedMonths) {
      for (const item2 of item1) {
        let currentVacationStatus = item2[0]["vacationStatus"];
        if (currentVacationStatus === undefined) {
          continue;
        }
        let index = vacationStatusConfigClone.findIndex(
          value => value["id"] === currentVacationStatus
        );
        if (index !== -1) {
          ++vacationStatusConfigClone[0]["count"];
          ++vacationStatusConfigClone[index]["count"];
        }
      }
    }

    this.setState({ vacationStatusConfig: vacationStatusConfigClone });
  };

  //
  //   *****************   FUNCTIONS  ***********************
  //

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleDisplayYearSelectItems = () => {
    this.setState(state => {
      return {
        yearDivIsVisible: !state.yearDivIsVisible
      };
    });
  };

  handleSelectYear = year => {
    const { dispatch } = this.props;
    this.setState({
      year: year,
      yearDivIsVisible: false
    });
    dispatch(initCalendarConfig());
    dispatch(fetchCollaboratorAbsenceCalendarSettings(year));
    this.props.onAnalyseDateChange &&
      this.props.onAnalyseDateChange(null, year);
  };

  handleClickOutsideYearSelect(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ yearDivIsVisible: false });
    }
  }

  handleToggleActivatedMonth = selectedMonth => {
    const { activated } = this.state;
    if (activated == null || activated !== selectedMonth) {
      this.setState({
        activated: selectedMonth
      });
    } else {
      this.setState({
        activated: null
      });
    }
  };

  initCalendarSelect = () => {
    const { dispatch } = this.props;
    dispatch(initCalendarSelect());
  };

  setCalendarSelectedDays = selectedDays => {
    const { dispatch } = this.props;
    dispatch(setCalendarSelectedDays(selectedDays));
  };

  setCalendarSelectedFiles = selectedFiles => {
    const { dispatch } = this.props;
    dispatch(setCalendarSelectedFiles(selectedFiles));
  };

  setCalendarActivatedOption = activatedOption => {
    const { dispatch } = this.props;
    dispatch(setCalendarActivatedOption(activatedOption));
  };

  setCalendarModifiers = modifiers => {
    const { dispatch } = this.props;
    dispatch(setCalendarModifiers(modifiers));
  };

  setCalendarPlanning = planning => {
    const { dispatch } = this.props;
    dispatch(setCalendarPlanning(planning));
  };

  setCalendarId = id => {
    const { dispatch } = this.props;
    dispatch(setCalendarId(id));
  };

  handleSendEmail = async label => {
    const {
      dispatch,
      currentOrganization,
      user,
      token,
      lng,
      attachments,
      selectedDays
    } = this.props;

    //managers
    const recipients = {
      528409: "yousra.berradi@oam.ma",
      458410: "yassine.el.bekkali21@gmail.com"
      // 470189: "eljemlisafae@gmail.com"
    };

    const fromDate = new Date(selectedDays.from);
    const toDate = new Date(selectedDays.to);

    const options = { day: "numeric", month: "long" };
    const fromdayAndMonth = fromDate.toLocaleDateString("fr-FR", options);
    const todayAndMonth = toDate.toLocaleDateString("fr-FR", options);

    let OBJET = `${user.firstName} ${
      user.lastName
    } a déposé un congé ${label} du ${fromdayAndMonth} au ${todayAndMonth}`;

    // Check if the last plan has attachments and append information if it does
    if (attachments && attachments.length > 0) {
      OBJET += ` avec les pièces jointes : `;
    }

    const dynamicFields = {
      "{{OBJET}}": OBJET,
      "{{ORGANIZATION.NAME}}": currentOrganization.name,
      // eslint-disable-next-line prettier/prettier
      "FIDUCIARY_LOGO": currentOrganization.avatarUrl
    };
    await dispatch(
      sendGenericEmailThunk(
        token,
        recipients,
        "ABSENCE_NOTIFICATION",
        lng,
        dynamicFields,
        currentOrganization.id,
        attachments
      )
    );
  };

  saveCalendarSettings = async (
    plan,
    label,
    month = null,
    isUpdating = "false",
    isDeleting
  ) => {
    const { dispatch, attachments, loggedAs } = this.props;
    const { year, activated } = this.state;

    loggedAs === "COLLABORATOR" && !isDeleting && this.handleSendEmail(label);

    return dispatch(
      saveCollaboratorAbsenceCalendarSettings(
        plan,
        year,
        month !== null ? month : activated,
        attachments,
        isUpdating
      )
    );
  };

  handleDisplayDeleteTagDates = (key, option, item) => {
    let dates = item.map(date => {
      return date.date;
    });

    this.setState({
      selectedTagKey: key,
      selectedTagOption: option,
      selectedTagDates: dates,
      deleteTagDatesIsVisible: true
    });
  };

  cancelDeleteTagDates = () => {
    this.setState({
      selectedTagKey: null,
      selectedTagOption: [],
      selectedTagDates: [],
      deleteTagDatesIsVisible: false
    });
  };

  deleteCalendarTagDatesSetting = () => {
    const { selectedTagOption, selectedTagDates } = this.state;
    const {
      data: { planning },
      modifiers
    } = this.props;

    let month = selectedTagDates[0].getMonth();

    let plan = clonedeep(planning);
    let modif = clonedeep(modifiers);

    plan = filterCollaboratorDatesTagsByOptions(
      plan,
      MONTHS[month],
      selectedTagDates,
      [selectedTagOption]
    );

    modif[selectedTagOption] = filterDates(
      modif[selectedTagOption],
      selectedTagDates
    );

    let planningDataToSave = prepareCollaboratorAbsencesForSave(
      plan,
      MONTHS[month],
      month,
      ["absence_1", "absence_2", "absence_3"]
    );

    this.saveCalendarSettings(
      planningDataToSave,
      null,
      month,
      "false",
      true
    ).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: _("Calendrier à jour")
        });
        this.setCalendarPlanning(plan);
        this.setCalendarModifiers(modif);
        this.cancelDeleteTagDates();
      },
      err => {
        onError(err.response.data.errors[0].message);
      }
    );
  };

  handleDisplayUpdateTagDates = (label, option, item) => {
    let dates = item.map(date => {
      return date.date;
    });

    let month = dates[0].getMonth();

    this.setState(
      {
        activated: month
      },
      () => {
        this.itemMonthRefs[month].current.setSelectedTagDataToUpdate(
          label,
          option,
          dates
        );
      }
    );
  };

  //
  //   *****************   RENDERING  ***********************
  //

  renderYearSelect = () => {
    const { yearDivIsVisible, year } = this.state;
    const { arrivalDate } = this.props;

    return (
      <div
        ref={this.setWrapperRef.bind(this)}
        className={
          styles.customed_select +
          " " +
          (this.state.yearDivIsVisible ? styles.customed_select_opened : "")
        }
        style={{
          position: "absolute",
          top: 0,
          right: 0
        }}
      >
        <div className={styles.customed_select_header}>
          <span>{year}</span>
          <div className={styles.actions}>
            <div>
              <span
                className={styles.action}
                onClick={this.handleDisplayYearSelectItems}
              >
                <i className={"icon icon-arrow-down"} />
              </span>
            </div>
          </div>
        </div>
        {yearDivIsVisible && (
          <div className={styles.customed_select_body}>
            <div className={styles.customed_select_body_options}>
              {YEARS_VALUES.filter(
                year => (arrivalDate ? year >= arrivalDate.year() : true)
              ).map((item, index) => (
                <div
                  key={index}
                  className={styles.customed_select_body_option}
                  onClick={() => this.handleSelectYear(item)}
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  renderCalenderStatComponent = (color, number, label) => {
    return (
      <div className={styles.calendar_stats_component}>
        <div className={styles.top_bar} style={{ background: color }} />
        <div className={styles.stat_shape} style={{ background: color }}>
          <span>
            {number} {_("j.")}
          </span>
        </div>
        <span className={styles.label}>{_(label)}</span>
      </div>
    );
  };

  renderMonthsBlocks = () => {
    const {
      lng,
      selectedDays,
      modifiers,
      notWorkingDays,
      activatedOption,
      data,
      saving,
      isFreelancer,
      currentNavPage,
      holidaysTypes,
      attachments,
      loggedAs,
      spaceAs
    } = this.props;

    const { months, year, holidaysNbrOfDays, collaborators } = this.state;
    let seniorityLeave =
      holidaysTypes &&
      holidaysTypes.filter(type => type.abbriviation === "CA")[0];

    return (
      <div className={classnames("row")}>
        {months.map((item, i) => {
          return (
            <div
              key={`month-${i}`}
              className={classnames(
                "columns medium-6 small-12",
                styles.item_div
              )}
            >
              <ItemMonth
                ref={this.itemMonthRefs[i]}
                month={item}
                monthNumber={i}
                collaborators={collaborators}
                lng={lng}
                year={year}
                data={data}
                attachments={attachments}
                isFreelancer={isFreelancer}
                selectedDays={selectedDays}
                modifiers={modifiers}
                notWorkingDays={notWorkingDays}
                activatedOption={activatedOption}
                setCalendarSelectedDays={this.setCalendarSelectedDays}
                setCalendarSelectedFiles={this.setCalendarSelectedFiles}
                setCalendarModifiers={this.setCalendarModifiers}
                setCalendarActivatedOption={this.setCalendarActivatedOption}
                validateCalendarMonthSetting={this.validateCalendarMonthSetting}
                refreshCalendar={this.fetchCollaboratorAbsenceCalendar}
                initCalendarSelect={this.initCalendarSelect}
                setCalendarPlanning={this.setCalendarPlanning}
                setCalendarId={this.setCalendarId}
                handleToggleActivatedMonth={this.handleToggleActivatedMonth}
                active={this.state.activated === i}
                saveCalendarSettings={this.saveCalendarSettings}
                saving={saving}
                currentNavPage={currentNavPage}
                holidaysTypes={holidaysTypes}
                seniorityLeave={seniorityLeave}
                holidaysNbrOfDays={holidaysNbrOfDays}
                loggedAs={loggedAs}
                spaceAs={spaceAs}
              />
            </div>
          );
        })}
      </div>
    );
  };

  generateVacationStatus = () => {
    let result = [];
    const { selectedVacationState } = this.state;

    selectedVacationState.forEach(status => {
      switch (status) {
        case VACATION_STATUS_CONFIG[0]["id"]:
          result.push(
            STATUS_VACATION.REJECTED,
            STATUS_VACATION.PENDING,
            STATUS_VACATION.APPROVED
          );
          break;
        case STATUS_VACATION.REJECTED:
          result.push(STATUS_VACATION.REJECTED);
          break;
        case STATUS_VACATION.PENDING:
          result.push(STATUS_VACATION.PENDING);
          break;
        case STATUS_VACATION.APPROVED:
          result.push(STATUS_VACATION.APPROVED);
          break;
        default:
          break;
      }
    });

    return result;
  };

  renderMonthsTags = () => {
    const {
      data: { planning }
    } = this.props;
    const { months } = this.state;

    let plan = planning;

    let monthsRendering = [];
    let options = [];
    for (let type in plan) {
      options.push(type);
    }

    let vacationStates = this.generateVacationStatus();

    for (let i in MONTHS) {
      let tags = mapAndSortCalendarPlanningByMonth(plan, MONTHS[i], options);

      if (tags.length === 0) {
        continue;
      }

      let newTags = [];
      for (let tag of tags) {
        const currentVacationStatus = tag[0]["vacationStatus"];
        if (
          (currentVacationStatus === undefined &&
            vacationStates.length === VACATION_STATUS_CONFIG.length - 1) ||
          vacationStates.includes(currentVacationStatus)
        ) {
          newTags.push(tag);
        }
      }

      if (newTags.length === 0) continue;

      monthsRendering.push(
        <div className={styles.tag_month} key={MONTHS[i]}>
          <span className={styles.tag_month_label}>{months[i]} :</span>
          {this.renderTags(MONTHS[i], newTags)}
        </div>
      );
    }

    return monthsRendering;
  };

  handleUpdateVacation = (label, option, item, vacationStatus) => {
    return new Promise((resolve, reject) => {
      const {
        data: { planning }
      } = this.props;
      let dates = item.map(date => {
        return date.date;
      });

      let month = dates[0].getMonth();

      let plan = clonedeep(planning);

      plan = filterCollaboratorDatesTagsByOptions(plan, MONTHS[month], dates, [
        "absence_1",
        "absence_2",
        "absence_3"
      ]);

      let key = Math.random()
        .toString(36)
        .substr(2, 9);
      dates.forEach((date, i) => {
        plan[option][MONTHS[month]].push({
          label:
            vacationStatus === STATUS_VACATION.REJECTED ? label.label : label,
          rejectReason:
            vacationStatus === STATUS_VACATION.REJECTED
              ? label.rejectReason
              : null,
          date: date,
          key: key,
          hours: 2,
          type: option,
          vacationStatus: vacationStatus,
          id: item[0]["id"]
        });
      });

      let planningDataToSave = prepareCollaboratorAbsencesForSave(
        plan,
        MONTHS[month],
        month,
        ["absence_1", "absence_2", "absence_3"]
      );

      planningDataToSave = planningDataToSave.filter(
        planL =>
          planL["vacationStatus"] === vacationStatus &&
          planL["id"] === item[0].id
      );

      this.saveCalendarSettings(
        planningDataToSave,
        label,
        month,
        "true",
        false
      ).then(
        res => {
          onSuccess(res, {
            title: _("saveSuccess"),
            body: _("Calendrier à jour")
          });
          this.setCalendarPlanning(plan);
          resolve(true);
        },
        err => {
          onError(err.response.data.errors[0].message);
          resolve(false);
        }
      );
    });
  };

  showPopconfirm = status => {
    this.setState({ popStatus: status });
  };

  handleOk = (label, option, item, statusVacation) => {
    this.setState({ confirmLoading: true });
    this.handleUpdateVacation(label, option, item, statusVacation).then(() => {
      this.setState({ popStatus: null, confirmLoading: false });
      if (statusVacation === STATUS_VACATION.REJECTED) {
        this.setState({
          calendarLabel: ""
        });
      }
    });
  };

  handleCancel = () => {
    this.setState({ popStatus: null });
  };

  displayAttachments = attachments => {
    this.setState({
      isAttachmentModalVisible: true,
      selectedAttachments: attachments
    });
  };

  handleCloseAttachmentModal = () => {
    this.setState({
      isAttachmentModalVisible: false,
      selectedAttachments: []
    });
  };

  renderTags = (month, tags) => {
    let tagsRendering = [];
    const {
      popStatus,
      calendarLabel,
      confirmLoading,
      selectedVacationState
    } = this.state;
    const { loggedAs, spaceAs } = this.props;

    tags.forEach((item, i) => {
      tagsRendering.push(
        <div
          className={classnames(
            styles.tag,
            item[0].option === "holidays"
              ? styles.holidays
              : item[0].option === "annualHolidays"
                ? styles.annualHolidays
                : item[0].option === "workingDays"
                  ? styles.workingDays
                  : item[0].option === "absence_1"
                    ? styles.absence_1
                    : item[0].option === "absence_2"
                      ? styles.absence_2
                      : styles.absence_3
          )}
          key={"month_tag_" + i}
        >
          <span className={classnames(styles.tag_color)} />
          <span
            className={classnames(
              styles.tag_label,
              selectedVacationState &&
              selectedVacationState.length === 1 &&
              selectedVacationState[0] === STATUS_VACATION.PENDING
                ? styles.full_width
                : styles.min_width
            )}
          >
            <div>
              {_(item[0].label)} :{" "}
              <b>
                {item.map((date, i) => {
                  return (i !== 0 ? " - " : "") + date.date.getDate();
                })}
              </b>
              {item[0].option === "absence_3"
                ? ` [${item[0].numberHours}h]`
                : ""}
              {item[0]["vacationStatus"] &&
                ((selectedVacationState &&
                  selectedVacationState[0] !== STATUS_VACATION.PENDING) ||
                  isCollaboratorAccess(loggedAs, spaceAs)) && (
                  <Tooltip
                    key={`rejectReason`}
                    placement="top"
                    title={item[0]["rejectReason"]}
                  >
                    <Tag
                      className={styles.vacation_status}
                      color={
                        item[0]["vacationStatus"] === STATUS_VACATION.PENDING
                          ? "gold"
                          : item[0]["vacationStatus"] ===
                            STATUS_VACATION.APPROVED
                            ? "green"
                            : item[0]["vacationStatus"] ===
                              STATUS_VACATION.REJECTED
                              ? "red"
                              : ""
                      }
                    >
                      {_(item[0]["vacationStatus"])}
                    </Tag>
                  </Tooltip>
                )}
              {item[0]["attachments"] ? (
                <Tag
                  onClick={() =>
                    this.displayAttachments(JSON.parse(item[0]["attachments"]))
                  }
                  className={styles.vacation_status}
                  style={{ margin: 0, cursor: "pointer" }}
                >
                  <span className="icon icon-paper-clip" />
                </Tag>
              ) : item[0].label === "Congé Maladie" ? (
                <Tooltip
                  key={"month_tag_" + item[0].id}
                  placement="top"
                  title={_("needToUploadAttachments")}
                >
                  <Tag
                    className={styles.vacation_status}
                    color="red"
                    style={{
                      marginLeft:
                        selectedVacationState[0] === STATUS_VACATION.PENDING
                          ? "1em"
                          : 0
                    }}
                  >
                    <span className="icon icon-exclamation" />
                  </Tag>
                </Tooltip>
              ) : (
                ""
              )}
              {item[0]["backup"] ? (
                <Tooltip
                  key={"month_tag_" + item[0].id}
                  placement="top"
                  title={`${_("backup")} : ${item[0]["backup"]}`}
                >
                  <Tag
                    className={styles.vacation_status}
                    style={{ margin: 0, cursor: "pointer" }}
                  >
                    <span className="icon icon-user" />
                  </Tag>
                </Tooltip>
              ) : (
                ""
              )}
            </div>
            {selectedVacationState &&
              selectedVacationState.length === 1 &&
              selectedVacationState[0] === STATUS_VACATION.PENDING &&
              (isManagerAccess(loggedAs, spaceAs) ||
                isAdminAccess(loggedAs, spaceAs) ||
                isSuperAdminAccess(loggedAs, spaceAs)) && (
                <div className={styles.pending_actions}>
                  <span
                    onClick={() => {
                      this.showPopconfirm(
                        `${POP_STATUS.REJECT}_${item[0].option}_${item.map(
                          (date, i) => {
                            return date.date.getDate();
                          }
                        )}_${i}`
                      );
                    }}
                  >
                    <img
                      src={"/img/icons/close.svg"}
                      className={styles.delete}
                      alt={""}
                    />
                  </span>
                  <Popconfirm
                    title={_("approvalMessage")}
                    visible={
                      popStatus ===
                      `${POP_STATUS.APPROVE}_${item[0].option}_${item.map(
                        (date, i) => {
                          return date.date.getDate();
                        }
                      )}_${i}`
                    }
                    onConfirm={() =>
                      this.handleOk(
                        item[0].label,
                        item[0].option,
                        item,
                        STATUS_VACATION.APPROVED
                      )
                    }
                    okButtonProps={{ loading: confirmLoading }}
                    onCancel={this.handleCancel}
                  >
                    <span
                      onClick={() => {
                        this.showPopconfirm(
                          `${POP_STATUS.APPROVE}_${item[0].option}_${item.map(
                            (date, i) => {
                              return date.date.getDate();
                            }
                          )}_${i}`
                        );
                      }}
                    >
                      <img
                        src={"/img/icons/check-mark.svg"}
                        className={styles.check_mark}
                        alt={""}
                      />
                    </span>
                  </Popconfirm>
                </div>
              )}
          </span>

          {selectedVacationState &&
          ((selectedVacationState[0] !== STATUS_VACATION.PENDING &&
            (isManagerAccess(loggedAs, spaceAs) ||
              isAdminAccess(loggedAs, spaceAs) ||
              isSuperAdminAccess(loggedAs, spaceAs))) ||
            (selectedVacationState[0] === STATUS_VACATION.PENDING &&
              isCollaboratorAccess(loggedAs, spaceAs))) &&
          !["holidays", "annualHolidays", "workingDays"].includes(
            item[0].option
          ) ? (
            <div
              className={styles.actions_container}
              onClick={event => {
                event.stopPropagation();
              }}
            >
              <div>
                <span
                  className={styles.action}
                  onClick={() =>
                    this.handleDisplayUpdateTagDates(
                      item[0].label,
                      item[0].option,
                      item
                    )
                  }
                >
                  <img
                    src={"/img/icons/pencil.svg"}
                    className={styles.back_arrow}
                    alt={""}
                  />
                </span>
                <span
                  className={styles.action}
                  onClick={() =>
                    this.handleDisplayDeleteTagDates(
                      item[0].key,
                      item[0].option,
                      item
                    )
                  }
                >
                  <img
                    src={"/img/icons/garbage.svg"}
                    className={styles.check_mark}
                    alt={""}
                  />
                </span>
              </div>
            </div>
          ) : (
            ""
          )}
          <Modal
            closable={false}
            maskClosable={true}
            destroyOnClose={true}
            visible={
              popStatus ===
              `${POP_STATUS.REJECT}_${item[0].option}_${item.map((date, i) => {
                return date.date.getDate();
              })}_${i}`
            }
            onOk={() =>
              this.handleOk(
                { label: item[0].label, rejectReason: calendarLabel },
                item[0].option,
                item,
                STATUS_VACATION.REJECTED
              )
            }
            onCancel={this.handleCancel}
          >
            <div className={styles.modal_content}>
              <div className={styles.title}>{_("rejectionMessage")}</div>
              <textarea
                type={"text"}
                placeholder={_("rejectReason") + " ..."}
                value={calendarLabel}
                onChange={e => {
                  this.setState({
                    calendarLabel: e.target.value
                  });
                }}
              />
            </div>
          </Modal>
        </div>
      );
    });

    return tagsRendering;
  };

  handleError = () => {
    const { error } = this.props;

    if (error.code === 170043) {
      return (
        <NotFoundV2
          errorPageType={"ACCESS_DENIED"}
          subText={"collaboratorNotLinkedToAnyZone"}
          text={"pleaseAssignHimAZoneBeforeSettingUpHisCalendar"}
          buttonIgnored={true}
        />
      );
    } else if (error.code === 170148) {
      return (
        <NotFoundV2
          errorPageType={"ACCESS_DENIED"}
          subText={"AnnualCalendarNotFound"}
          text={"pleaseConfigureTheCompanysAnnualCalendarBefore"}
          buttonIgnored={true}
        />
      );
    } else {
      return (
        <NotFoundV2
          errorPageType={"ACCESS_DENIED"}
          text={"errorOccured"}
          buttonIgnored={true}
        />
      );
    }
  };

  handleVacationStateChange = selected => {
    this.setState({ selectedVacationState: selected });
  };

  render() {
    const {
      token,
      fetching,
      fetched,
      saving,
      modifiers,
      holidaysTypes,
      collaboratorPeriodSetting,
      data: { collaboratorId },
      error,
      loggedAs,
      spaceAs
    } = this.props;

    const {
      selectedAttachments,
      holidaysNbrOfDays,
      vacationStatusConfig,
      selectedVacationState
    } = this.state;

    let seniorityLeaveData =
      holidaysTypes &&
      holidaysTypes.filter(type => type.abbriviation === "CA")[0];
    if (
      fetched &&
      !holidaysNbrOfDays.absence_1 &&
      collaboratorPeriodSetting &&
      collaboratorPeriodSetting[1]
    ) {
      this.setState({
        holidaysNbrOfDays: {
          absence_1: collaboratorPeriodSetting[1],
          absence_sl:
            seniorityLeaveData &&
            collaboratorPeriodSetting[seniorityLeaveData.value]
              ? collaboratorPeriodSetting[seniorityLeaveData.value]
              : 0
        },
        seniorityLeave: seniorityLeaveData
      });
    }

    return (
      <div className={classnames(styles.calendar_settings, "page-content")}>
        {/*<SettingPageHeader*/}
        {/*  title={_("calendarSettings")}*/}
        {/*  onBack={() => this.handleRedirectBack()}*/}
        {/*/>*/}
        <div className={styles.months_block} style={{ width: "100%" }}>
          <div className={classnames("row")}>
            <div className={classnames("columns medium-8 small-12")}>
              <div className={styles.title_block}>
                <h2 className={styles.title}>{_("calendarSettings")}</h2>
                <h3 className={styles.subtitle}>
                  {isCollaboratorAccess(loggedAs, spaceAs)
                    ? _("ManageMyCalendar")
                    : _("ManageTheCollaboratorsCalendar")}
                </h3>
                {/* {this.renderYearSelect()} */}
              </div>
              {fetching && (
                <div className={styles.ripple_loading_adapted}>
                  <img src={"/img/Ripple-1s-150px.svg"} alt="" />
                </div>
              )}
              {fetched && this.renderMonthsBlocks()}

              {!fetching && error && this.handleError()}
            </div>
            <div className={classnames("columns medium-4 small-12")}>
              <div className={styles.calendar_stats_container}>
                {/******************      Stats Shape        ******************/}
                <div className={classnames(styles.stats_background)}>
                  <div className={classnames("")} style={{ width: "25%" }}>
                    {this.renderCalenderStatComponent(
                      HOLIDAYS_COLOR,
                      modifiers.holidays.length,
                      "holidays"
                    )}
                  </div>
                  <div className={classnames("")} style={{ width: "25%" }}>
                    {this.renderCalenderStatComponent(
                      ANNUAL_HOLIDAYS_COLOR,
                      modifiers.annualHolidays.length,
                      "annualHolidays"
                    )}
                  </div>
                  <div className={classnames("")} style={{ width: "25%" }}>
                    {this.renderCalenderStatComponent(
                      ABSENCES_COLOR,
                      modifiers.absence_1
                        ? modifiers.absence_1.length +
                          "/" +
                          (parseInt(holidaysNbrOfDays.absence_1) +
                            parseInt(holidaysNbrOfDays.absence_sl))
                        : 0,
                      "myVacations"
                    )}
                  </div>
                  <div className={classnames("")} style={{ width: "25%" }}>
                    {this.renderCalenderStatComponent(
                      OTHER_ABSENCES_COLOR,
                      modifiers.absence_2 ? modifiers.absence_2.length : 0,
                      "others"
                    )}
                  </div>
                </div>
                <div className={styles.stats_background_oval_shape} />

                {/******************      Stats Tags        ******************/}
                <div style={{ margin: "40px 16px 8px" }}>
                  <StateFilter
                    majorKey={vacationStatusConfig[0]["id"]}
                    configState={vacationStatusConfig}
                    handleStateChange={this.handleVacationStateChange}
                    selectedState={selectedVacationState}
                    multiSelect={false}
                  />
                </div>
                <div className={styles.tags_container}>
                  {fetched && this.renderMonthsTags()}
                </div>
              </div>
            </div>
          </div>
        </div>
        <TTPModal
          footer={null}
          width={982}
          height={400}
          visible={this.state.isAttachmentModalVisible}
        >
          <div className="tamtam-modal upload-modal upload-modal__body">
            <ModalCloseButton onClose={this.handleCloseAttachmentModal} />
            {selectedAttachments.map((file, index) => {
              return (
                <div className={styles.file_view}>
                  <iframe
                    id={`annexe-${index}`}
                    style={{ width: "100%" }}
                    src={
                      getTemporaryAnnexeFileLink(collaboratorId, file, token) ||
                      ""
                    }
                  />
                </div>
              );
            })}
          </div>
        </TTPModal>
        <TTPDialog
          showDialog={this.state.deleteTagDatesIsVisible}
          loading={saving}
          TTPDialog={{
            approvedAction: this.deleteCalendarTagDatesSetting,
            abortAction: this.cancelDeleteTagDates,
            message: _("confirmationDeleteCalendarConfigMessage"),
            icon: <GarbageIcon />,
            proceedBtnLabel: _("yes"),
            abortBtnLabel: _("No"),
            type: DIALOG_TYPES.ALERT,
            title: "confirmationDeleteCategoryTitle"
          }}
        />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  lng: state.params.lng,
  token: state.auth.token,
  selectedDays: state.calendarSettings.selectedDays,
  modifiers: state.calendarSettings.modifiers,
  activatedOption: state.calendarSettings.activatedOption,
  data: state.calendarSettings.data,
  error: state.calendarSettings.error,
  holidaysTypes:
    state.calendarSettings.data && state.calendarSettings.data.holidaysTypes,
  attachments: state.calendarSettings.files,
  isFreelancer:
    state.calendarSettings.data && state.calendarSettings.data.isFreelancer,
  notWorkingDays:
    state.calendarSettings.data && state.calendarSettings.data.notWorkingDays,
  collaboratorPeriodSetting:
    state.calendarSettings.data &&
    state.calendarSettings.data.collaboratorPeriodSetting,
  saving: state.calendarSettings.saving,
  saved: state.calendarSettings.saved,
  fetching: state.calendarSettings.fetching,
  fetched: state.calendarSettings.fetched,
  currentNavPage: state.params.currentNavPage,
  loggedAs: selectLoggedAs(state),
  spaceAs: state.auth && state.auth.spaceAs,
  currentOrganization: state.auth && state.auth.currentOrganization,
  user: state.auth && state.auth.user
});

export default connect(mapStateToProps)(CalendarSettingsPage);



// WEBPACK FOOTER //
// ./src/components/CapacityPlanning/CollaboratorCalendarContainer.js